import React, { FC } from "react";

import { Route, Routes } from "react-router-dom";
import ContactDetailsInfo from "@app/pages/private/contactDetails/contactDetailsInfo";
import CreateOrUpdateAddress from "@app/pages/private/contactDetails/createOrUpdateAddress";
import UpdatePhone from "@app/pages/private/contactDetails/updatePhone";

const ContactDetails: FC = () => {
  return (
    <Routes>
      <Route
        path="/create_or_update_address"
        element={<CreateOrUpdateAddress />}
      />
      <Route path="/update_phone" element={<UpdatePhone />} />
      <Route index element={<ContactDetailsInfo />} />
    </Routes>
  );
};

export default ContactDetails;
